import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
} from '@mui/material';
import InviteManagement from './InviteManagement';
import ReferralsTracking from './ReferralsTracking';
import AdminReferralStats from './AdminReferralStats';
import PromoCodeManagement from './PromoCodeManagement';
import ChampionsManagement from './ChampionsManagement';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`referral-tabpanel-${index}`}
      aria-labelledby={`referral-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `referral-tab-${index}`,
    'aria-controls': `referral-tabpanel-${index}`,
  };
}

const ReferralContent = ({ isChampions = false }) => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const tabs = [
    ...(!isChampions ? [{
      label: 'Champions Management',
      component: <ChampionsManagement />,
      icon: null,
    }] : []),
    {
      label: 'Invites',
      component: <InviteManagement isChampions={isChampions} />,
      icon: null,
    },
    ...(!isChampions ? [{
      label: 'Promo Codes',
      component: <PromoCodeManagement isChampions={isChampions} />,
      icon: null,
    }] : []),
    {
      label: 'Tracking',
      component: <ReferralsTracking isChampions={isChampions} />,
      icon: null,
    },
    ...(!isChampions ? [{
      label: 'Statistics',
      component: <AdminReferralStats isChampions={isChampions} />,
      icon: null,
    }] : []),
  ];

  return (
    <Box sx={{ width: '100%' }}>
      {/* Page Title - Aligned with sidebar */}
      <Box sx={{ 
        p: 2, 
        pb: 1,
        borderBottom: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.paper'
      }}>
        <Typography 
          variant="h4" 
          sx={{ 
            fontWeight: 700, 
            color: 'text.primary',
            fontSize: '1.5rem'
          }}
        >
          {isChampions ? 'Champions Referral' : 'Referral Management'}
        </Typography>
      </Box>
      
      <Box sx={{ p: 3 }}>
        <Paper sx={{ width: '100%', mb: 2 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              aria-label="referral management tabs"
              variant="scrollable"
              scrollButtons="auto"
            >
              {tabs.map((tab, index) => (
                <Tab
                  key={index}
                  label={tab.label}
                  {...a11yProps(index)}
                  icon={tab.icon}
                  iconPosition="start"
                />
              ))}
            </Tabs>
          </Box>
        </Paper>

        {tabs.map((tab, index) => (
          <TabPanel key={index} value={tabValue} index={index}>
            {tab.component}
          </TabPanel>
        ))}
      </Box>
    </Box>
  );
};

export default ReferralContent;
